export default "__VITE_ASSET__55e6ad1c__"